import { ANALYTICS_EVENT_NAME, type AnalyticsEvent } from "@/analytics/events";
import type { DemoId } from "@/demos/types";

let opened = false;

// A DOM event, so a consumer can be attached (or not) without this module ever
// being able to block rendering or navigation on a network call.
function emit(event: AnalyticsEvent): void {
  window.dispatchEvent(new CustomEvent<AnalyticsEvent>(ANALYTICS_EVENT_NAME, { detail: event }));
}

export function trackExperienceOpened(demoId: DemoId): void {
  if (opened) return;
  opened = true;
  emit({ name: "experience_opened", demoId });
}

export function trackCtaClicked(demoId: DemoId): void {
  emit({ name: "cta_clicked", demoId, ctaId: "primary" });
}

export function resetAnalyticsSessionForTests(): void {
  opened = false;
}
